import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "edit-tax-account-content" }
const _hoisted_2 = { class: "fl-l" }

import { ref, watch } from 'vue'
import { t } from '@/plugins/i18n'
import { useMust } from '@/util/useRules'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { taxAccountEdit, taxAccountAdd } from '@/apis/user'
import data from '../guide/data'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: ['type', 'visible', 'data'],
  emits: ['update:data', 'update:visible', 'refresh'],
  setup(__props, { emit }) {

const props = __props
const store = useStore()




const rules = {
  financialInstitutionCode: useMust(t('必填')),
  branchCode: useMust(t('必填')),
  taxDeductionAccount: useMust(t('必填')),
  importerCode: useMust(t('必填'))
}

const form = ref({})
watch(() => props.data, (val) => {
  form.value = val
  val.isDefault ? (form.value.isDefault = true) : (form.value.isDefault = false)
})

const open = (form = {}) => {
  // visible.value = true
}
const cancel = () => {
  emit('update:visible', false)
}
const formRef = ref()
const commit = () => {
  const api = (props.type === 'edit' ? taxAccountEdit : taxAccountAdd)
  formRef.value.validate((valid) => {
    if (valid) {
      api({
        ...form.value,
        customerShopId: store.getters.curShop,
        isDefault: form.value.isDefault ? 1 : 0
      }).then(res => {
        emit('refresh')
        emit('update:visible', false)
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createBlock(CommonDialog, {
    visible: __props.visible,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    onOk: commit,
    onCancel: cancel,
    title: __props.type === 'edit' ? _unref(t)('编辑') : _unref(t)('添加新账号'),
    width: 650,
    footer: true
  }, {
    "footer-slot": _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_checkbox, {
          modelValue: form.value.isDefault,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.isDefault) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('设为默认扣税账号')), 1)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          "label-width": "180px",
          ref: (_value, _refs) => {
            _refs['formRef'] = _value
            formRef.value = _value
          },
          rules: rules,
          model: form.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('金融机构代码'),
              prop: "financialInstitutionCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.financialInstitutionCode,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.financialInstitutionCode) = $event)),
                  placeholder: _unref(t)('金融机构代码'),
                  maxlength: "50"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('分行代码'),
              prop: "branchCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.branchCode,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.branchCode) = $event)),
                  placeholder: _unref(t)('分行代码'),
                  maxlength: "50"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('账号_关税'),
              prop: "taxDeductionAccount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.taxDeductionAccount,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.taxDeductionAccount) = $event)),
                  placeholder: _unref(t)('账号'),
                  maxlength: "50"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('进口商标准代码'),
              prop: "importerCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.importerCode,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.importerCode) = $event)),
                  placeholder: _unref(t)('进口商标准代码'),
                  maxlength: "50"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})